<template>
<div id="app">
    <router-view></router-view>
</div>
</template>

<script>
import router from "../.././router";
import {
    LOGOUT,
    LOGIN
} from "../.././vuex/mutation_types";
export default {
    name: 'App',
    data() {
        return {
            active_page: '', // 当前页面路径
            isLogin: false, // 登录状态,
            errorImg: '/statics/images/nav_e.png',   // image 加载失败图片
			beforeUnloadTime: null, // 为了监听浏览器的关闭
			gapTime: null, // 为了监听浏览器的关闭
        }
    },
    mounted() {
		// 判断是否为微信浏览器
		// let ua = window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i);
		// ua = ua !== null ? ua[0] : null;
		// console.log('浏览器ua',ua);
		// if(ua === "micromessenger"){
		// 	window.addEventListener('pagehide', e => this.wechatUnloadHandler(e))
        //     window.addEventListener('unload', e => this.unloadHandler(e))
		// }else{
		// 	// 普通浏览器
		// 	window.addEventListener('beforeunload', e => this.beforeunloadHandler(e));
		// 	window.addEventListener('unload', e => this.unloadHandler(e))
		// };
	},
    created() {
        this.active_page = this.$route.path;
    },
    watch: {
        '$route': function (to, from) {
            // console.log(to.path);
            if (window.localStorage.user_name != undefined && window.localStorage.user_name != null && window.localStorage.user_name != '') {
                this.name = window.localStorage.user_name;
                this.isLogin = true
            } else {
                this.name = '';
                this.isLogin = false;
            }
            this.active_page = to.path;
        }
    },
    methods: {
		/**
		 * @name: 为了监听浏览器的关闭
		 * @return {*}
		 * @desc: 
		 */		
		wechatUnloadHandler(){
			alert('2');
			localStorage.removeItem('pingyaoNum');
		},
		/**
		 * @name: 为了监听浏览器的关闭
		 * @return {*}
		 * @desc: 
		 */		
		beforeunloadHandler(){
			this.beforeUnloadTime = new Date().getTime();
			alert('要关闭了');
			// debugger;
		},
		/**
		 * @name: 为了监听浏览器的关闭
		 * @return {*}
		 * @desc: 
		 */		
		unloadHandler(){
			this.gapTime = new Date().getTime() - this.beforeUnloadTime;
			alert('关闭');
			// debugger;
			// 判断浏览器是关闭还是刷新
			if(this.gapTime <= 5){
				console.log('浏览器是关闭,不是刷新');
				localStorage.removeItem('pingyaoNum');
			}else{
				console.log('浏览器是刷新,不是关闭');
			}
		}
    },
	destroyed() {
		window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e));
		window.removeEventListener('unload', e => this.unloadHandler(e));
		window.removeEventListener('pagehide', e => this.wechatUnloadHandler(e));
	},
}
</script>
